import { FC } from 'react';
import { Avatar, List } from 'antd';
import Icon from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react';

import { getImageTagDataByDeviceType, ImageTagData } from '@/constants/CompressorImageTagData.const';
import { useStores } from '@/hooks/use-stores';

import { StyledList } from './ImageTags.styles';

type Props = {
  className?: string;
};

export const ImageTags: FC<Props> = observer(({ className }) => {
  const { t } = useTranslation();
  const { mapBuilderStore } = useStores();

  return (
    <StyledList
      className={className}
      itemLayout="horizontal"
      dataSource={getImageTagDataByDeviceType(mapBuilderStore.selectedDevice?.deviceType)}
      split={false}
      renderItem={({ tag, Svg, translationKey }: ImageTagData) => (
        <List.Item key={tag} className="image-tag-item">
          <List.Item.Meta
            className="image-tag-meta"
            avatar={
              <Avatar className="image-tag-avatar">
                <Icon component={Svg} />
              </Avatar>
            }
            title={<p className="image-tag-title">{t(translationKey)}</p>}
          />
        </List.Item>
      )}
    />
  );
});
